import { render, staticRenderFns } from "./StoryblokFooterWide.vue?vue&type=template&id=18271c35&scoped=true&"
import script from "./StoryblokFooterWide.vue?vue&type=script&lang=js&"
export * from "./StoryblokFooterWide.vue?vue&type=script&lang=js&"
import style0 from "./StoryblokFooterWide.vue?vue&type=style&index=0&id=18271c35&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18271c35",
  null
  
)

export default component.exports